export enum StorageType {
    BrowserWindow = 'BrowserWindow',
    BrowserTab = 'BrowserTab',
    BrowserInMemory = 'BrowserInMemory',
}

export enum FirebaseStorageType {
    SessionStorage,
    LocalStorage,
    InMemory
}
